import React from 'react';
import PrintSafeImage from '../PrintSafeImage';
import { sanitizeRichText } from '../../utils/pastTripsAlbumTemplate';

const getPhoto = (items, index) => items?.[index] || null;

export default function JournalShort({ items = [], meta = {}, isPrinting }) {
  const photo = getPhoto(items, 0);
  const journalText = meta?.journalText || "Use the editor to add a short story or caption for this photo.";
  const position = photo?.position || { x: 50, y: 50, scale: 100 };
  const photoStyle = isPrinting ? {
  // PDF-safe styles
  position: 'absolute',
  width: '100%',
  height: 'auto',
  minWidth: '100%',
  minHeight: '100%',
  top: '50%',
  left: '50%',
  transform: `translate(-50%, -50%) scale(${position.scale / 100}) translateX(${position.x - 50}%) translateY(${position.y - 50}%)`,
} : {
  // LIVE PREVIEW styles (reverted to object-fit)
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
  objectPosition: `${position.x}% ${position.y}%`,
  transform: `scale(${position.scale / 100})`,
  transformOrigin: `${position.x}% ${position.y}%`,
};

  return (
    <div style={{ display: 'flex', boxSizing: 'border-box', padding: '32px', gap: '24px', width: '100%', height: '100%', alignItems: 'center', backgroundColor: '#ffffff' }}>
      {/* Photo on the left */}
      <div style={{ flex: '1 1 55%', height: '80%' }}>
        <div style={{ width: '100%', height: '100%', backgroundColor: '#e0e0e0', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', position: 'relative' }}>
          {photo?.url && 
  <PrintSafeImage 
    src={photo.url} 
    alt="" 
    style={photoStyle} 
    position={position} 
    isPrinting={isPrinting} 
  />
}
        </div>
      </div>
      
      {/* Text on the right */}
      <div style={{ flex: '1 1 45%', fontFamily: 'Georgia, serif', color: '#333' }}>
        <div 
          style={{ 
            fontSize: '15px', 
            lineHeight: '1.7', 
            maxHeight: '400px', 
            overflowY: 'auto' 
          }}
          dangerouslySetInnerHTML={{
            __html: sanitizeRichText(journalText)
          }}
        />
      </div>
    </div>
  );
}